import * as React from 'react';
import { Svg, Path, Circle } from 'react-native-svg';
import { memo } from 'react';
import type { IconProps } from '../helpers/icon-props';

const Icon = (props: IconProps) => {
  const { size = 24, ...otherProps } = props;
  return (
    <Svg width={size} height={size} viewBox="0 0 512 512" {...otherProps}>
      <Path
        d="M512 256c0 141.384-114.616 256-256 256S0 397.384 0 256C0 256.061 256 .028 256 0c141.384 0 256 114.616 256 256"
        fill="#0052b4"
      />
      <Path d="M256 0h-.043zM255.315 256H256v-.685z" fill="#f0f0f0" />
      <Path
        d="M256 133.565V0h-.043C114.591.024 0 114.629 0 256h133.565v-75.211L208.776 256h46.54l.685-.685v-46.537l-75.213-75.213z"
        fill="#f0f0f0"
      />
      <Circle cx={367.304} cy={144.696} r={44.522} fill="#6da544" />
      <Path
        d="M129.515 33.391a257.2 257.2 0 0 0-96.124 96.124V256h66.783V100.174H256V33.391z"
        fill="#d80027"
      />
      <Path
        d="m256 224.519-90.955-90.953h-31.48v.002L255.998 256H256zM289.391 133.565h155.826v66.783H289.391z"
        fill="#d80027"
      />
      <Path d="M445.217 256v-.001zM289.391 256v-.001z" fill="#496e2d" />
      <Path
        d="M289.391 300.522v44.522h23.424c14.045 13.764 33.27 22.261 54.489 22.261s40.444-8.497 54.489-22.261h23.424v-44.522z"
        fill="#ffda44"
      />
      <Path
        d="M289.391 189.217V256c0 59.639 77.913 77.913 77.913 77.913s77.913-18.274 77.913-77.913v-66.783z"
        fill="#338af3"
      />
      <Path
        d="M367.3 224.889c-19.477 0-19.477 17.809-38.954 17.809s-19.477-17.809-38.954-17.809v31.165c19.477 0 19.477 17.809 38.954 17.809s19.477-17.809 38.954-17.809c19.479 0 19.479 17.809 38.959 17.809s19.479-17.809 38.959-17.809v-31.165c-19.479 0-19.479 17.809-38.959 17.809s-19.48-17.809-38.959-17.809M367.3 162.504c-19.477 0-19.477 17.809-38.954 17.809s-19.477-17.809-38.954-17.809v31.165c19.477 0 19.477 17.809 38.954 17.809s19.477-17.809 38.954-17.809c19.479 0 19.479 17.809 38.959 17.809s19.479-17.809 38.959-17.809v-31.165c-19.479 0-19.479 17.809-38.959 17.809s-19.48-17.809-38.959-17.809"
        fill="#f3f3f3"
      />
    </Svg>
  );
};
Icon.displayName = 'CaymanIslands';
export const CaymanIslands = memo<IconProps>(Icon);
